<button
  [attr.id]="'service-item-' + uuid"
  [attr.aria-controls]="'service-item-content-' + uuid"
  [attr.aria-expanded]="expandOpen"
  class="fill flex no-outline"
  [class.pr-small-x]="includePaddings"
  [class.pr-small-t]="includePaddings"
  (click)="expandOpen = !expandOpen"
  [disabled]="disabled"
>
  <div class="btn-content fill flex flex--space-between">
    <span class="flex flex--top ms-xsmall-r fill">
      <fcom-icon [name]="getIconForService()" class="ir-xsmall ms-xsmall-r nordic-blue-900-text"></fcom-icon>
      <span class="flex-1 medium-type font-body-1 flex align-left flex--wrap">
        <span class="flex-1">{{ buttonTranslationKey | finLocalization }}</span>
        <span class="flex--nogrow">{{ additionalTitle }}</span>
      </span>
    </span>

    <fcom-icon
      name="chevron-down"
      class="flex-1 flex--nogrow rotate ir-xsmall nordic-blue-900-text"
      [class.rotate-active]="expandOpen"
    ></fcom-icon>
  </div>
</button>

<fcom-expand
  class="block"
  [open]="expandOpen"
  [ariaId]="'service-item-content-' + uuid"
  [ariaLabelledBy]="'service-item-' + uuid"
>
  <div [ngClass]="{ 'ms-xsmall-t': !includePaddings, 'mr-small-t pr-small-x': includePaddings }">
    <ng-content></ng-content>
  </div>
</fcom-expand>
